module.exports = __webpack_public_path__ + "static/media/desc_banner_data_Golang-06.1d9742de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/golangdesenv/desc_banner_data_Golang-06.png
// module id = 97
// module chunks = 0